<app-page-title title="Área"></app-page-title>
<div class="search-container" *ngIf="areas.length > 0">
  <input
    class="search-input"
    placeholder="Buscar..."
    [(ngModel)]="searchValue"
    (input)="search($event.target.value)"
    autocomplete="off"
  />
  <div class="search-img">
    <img src="../../../assets/icons/search-white.svg" sizes="1" />
  </div>
</div>
<br />

<app-no-data *ngIf="areas.length == 0" title="Sem dados" subtitle=" Nenhuma célula cadastrada"></app-no-data>
<cdk-virtual-scroll-viewport itemSize="50" class="viewport">
  <div *ngFor="let area of areas" class="area-container">
    <p class="description">
      {{ area?.description }}
    </p>

    <div class="button-actions">
      <img
        class="btn-delete"
        src="../../../assets/icons/visibility_black_24dp.svg"
        matTooltip="Vizualizar"
        [routerLink]="['/area/vizualizar/' + area.id]"
      />
      <img
        class="btn-edit"
        src="../../../assets/icons/edit.svg"
        matTooltip="Editar"
        [routerLink]="['/area/' + area.id]"
      />
      <img
        class="btn-delete"
        src="../../../assets/icons/delete.svg"
        matTooltip="Remover"
        (click)="delete(area.id, area.description)"
      />
    </div>
  </div>
</cdk-virtual-scroll-viewport>
<!-- <div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>


    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.description }}</td>
    </ng-container>


    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <img
          class="btn-edit"
          src="../../../assets/icons/visibility_black_24dp.svg"
          matTooltip="Vizualizar"
          [routerLink]="['/area/vizualizar/' + element.id]"
        />
        <img
          class="btn-edit"
          src="../../../assets/icons/edit.svg"
          matTooltip="Editar"
          (click)="openEdit(element.id)"
        />
        <img
          class="btn-delete"
          src="../../../assets/icons/delete.svg"
          matTooltip="Remover"
          (click)="delete(element.id, element.description)"
        />
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
  ></mat-paginator>
</div>
 -->
<div class="example-button-container">
  <button mat-fab color="primary" aria-label="Example icon button with a delete icon" [routerLink]="['/area/add']">
    <img src="../../../assets/icons/add_white_24dp.svg" />
  </button>
</div>
